var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1428 6.78952C9.90763 6.45845 10.1443 6 10.5504 6H37.4487C37.8547 6 38.0914 6.45845 37.8563 6.78952L33.4455 13H14.5536L10.1428 6.78952Z",
    fill: "#4C4AEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 6L23.9994 15V33L23.9998 42L8.5 33V15L23.9998 6Z",
    fill: "url(#paint0_linear_11184_60499)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0004 6L39.5001 15V33L24.0004 42V33L24 15L24.0004 6Z",
    fill: "url(#paint1_linear_11184_60499)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 24.9615L39.4998 32.9996L24 41.9996V32.9996L24.0002 24.9615Z",
    fill: "black",
    fillOpacity: 0.06
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.9573L24.5092 24.9617L8.50018 32.9573V23.9573L8.5 14.9573Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 14.199L32.8258 19.3238V29.5734L23.9999 34.6982L15.174 29.5734V19.3238L23.9999 14.199Z",
    fill: "url(#paint2_linear_11184_60499)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11184_60499",
    x1: 16.2499,
    y1: 6,
    x2: 16.2499,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1FF5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11184_60499",
    x1: 31.7501,
    y1: 6,
    x2: 31.7501,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#338BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11184_60499",
    x1: 18.6791,
    y1: 13.7833,
    x2: 28.6784,
    y2: 34.6539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/랭킹.3f1ca576a65571d0e8bb14ad2c2ba374.svg";
export { ForwardRef as ReactComponent };